import { render, staticRenderFns } from "./ReceivePriceSearch_Search.vue?vue&type=template&id=071771f4&"
import script from "./ReceivePriceSearch_Search.vue?vue&type=script&lang=js&"
export * from "./ReceivePriceSearch_Search.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports